import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = { class: "col-8" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 p-inputgroup" }
const _hoisted_5 = { class: "p-inputgroup-addon" }
const _hoisted_6 = { class: "col-12 p-inputgroup" }
const _hoisted_7 = { class: "p-inputgroup-addon" }
const _hoisted_8 = { class: "col-12 p-inputgroup" }
const _hoisted_9 = { class: "p-inputgroup-addon" }
const _hoisted_10 = { class: "col-12 p-inputgroup" }
const _hoisted_11 = { class: "p-inputgroup-addon" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "grid" }
const _hoisted_14 = { class: "col-12 p-inputgroup" }
const _hoisted_15 = { class: "p-inputgroup-addon" }
const _hoisted_16 = { class: "col-12 p-inputgroup" }
const _hoisted_17 = { class: "p-inputgroup-addon" }
const _hoisted_18 = { class: "grid" }
const _hoisted_19 = { class: "col-8" }
const _hoisted_20 = { class: "grid" }
const _hoisted_21 = { class: "col-12 p-inputgroup" }
const _hoisted_22 = { class: "p-inputgroup-addon" }
const _hoisted_23 = { class: "col-12 p-inputgroup" }
const _hoisted_24 = { class: "p-inputgroup-addon" }
const _hoisted_25 = { class: "col-6 p-inputgroup" }
const _hoisted_26 = { class: "p-inputgroup-addon" }
const _hoisted_27 = { class: "col-6 p-inputgroup" }
const _hoisted_28 = { class: "p-inputgroup-addon" }
const _hoisted_29 = { class: "col-6 p-inputgroup" }
const _hoisted_30 = { class: "p-inputgroup-addon" }
const _hoisted_31 = { class: "col-6 p-inputgroup" }
const _hoisted_32 = { class: "p-inputgroup-addon" }
const _hoisted_33 = {
  key: 0,
  class: "col-4"
}
const _hoisted_34 = { class: "grid p-fluid" }
const _hoisted_35 = { class: "col-10 md:col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.organization.form.basicData")), 1),
    ($setup.state.organizationDto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.t("content.dataManagement.content.organization.form.name")), 1),
                _createVNode(_component_InputText, {
                  modelValue: $setup.state.organizationDto.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.organizationDto.name) = $event)),
                  placeholder: 
                $setup.t('content.dataManagement.content.organization.form.name')
              
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString($setup.t("content.dataManagement.content.organization.form.nameEng")), 1),
                _createVNode(_component_InputText, {
                  modelValue: $setup.state.organizationDto.nameEnglish,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.organizationDto.nameEnglish) = $event)),
                  placeholder: 
                $setup.t('content.dataManagement.content.organization.form.nameEng')
              
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString($setup.t("content.dataManagement.content.organization.form.number")), 1),
                _createVNode(_component_InputNumber, {
                  modelValue: $setup.state.organizationDto.number,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.organizationDto.number) = $event)),
                  placeholder: 
                $setup.t('content.dataManagement.content.organization.form.number')
              ,
                  "use-grouping": false
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString($setup.t("content.dataManagement.content.organization.form.webURL")), 1),
                _createVNode(_component_InputText, {
                  modelValue: $setup.state.organizationDto.websiteURL,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.organizationDto.websiteURL) = $event)),
                  placeholder: "URL"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString($setup.t("content.dataManagement.content.organization.form.ri")), 1),
                _createVNode(_component_MultiSelect, {
                  modelValue: $setup.state.organizationDto.researchInfrastructureIds,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.organizationDto.researchInfrastructureIds) = $event)),
                  options: $setup.researchInfrastructureState.group,
                  "option-label": "name",
                  "option-value": "id",
                  placeholder: $setup.t('content.globalSelectTitle')
                }, {
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.t(
                "content.dataManagement.content.organization.form.contactPerson"
              )), 1),
                _createVNode(_component_MultiSelect, {
                  modelValue: $setup.state.organizationDto.userIds,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.organizationDto.userIds) = $event)),
                  options: $setup.state.filteredUsers,
                  "option-label": "firstname",
                  "option-value": "id",
                  placeholder: $setup.t('content.globalSelectTitle')
                }, {
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.firstname) + " " + _toDisplayString(slotProps.option.lastname), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "placeholder"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.organization.form.locationData")), 1),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString($setup.t("content.dataManagement.content.form.city")), 1),
            _createVNode(_component_Dropdown, {
              modelValue: $setup.state.organizationDto.cityId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.organizationDto.cityId) = $event)),
              options: $setup.getResearchCategories.cities,
              "option-label": "cityName",
              "option-value": "id",
              placeholder: $setup.t('content.globalSelectTitle')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString($setup.t("content.dataManagement.content.form.address")), 1),
            _createVNode(_component_AutoComplete, {
              modelValue: $setup.state.organizationDto.street,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.organizationDto.street) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.address')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, _toDisplayString($setup.t("content.dataManagement.content.form.postalCode")), 1),
            _createVNode(_component_AutoComplete, {
              modelValue: $setup.state.organizationDto.postalCode,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.organizationDto.postalCode) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.postalCode')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString($setup.t("content.dataManagement.content.form.department")), 1),
            _createVNode(_component_InputText, {
              modelValue: $setup.state.organizationDto.department,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.organizationDto.department) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.department')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString($setup.t("content.dataManagement.content.form.latitude")), 1),
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.organizationDto.latitude,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.organizationDto.latitude) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.latitude'),
              mode: "decimal",
              "min-fraction-digits": 6
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString($setup.t("content.dataManagement.content.form.longitude")), 1),
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.organizationDto.longitude,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.organizationDto.longitude) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.longitude'),
              mode: "decimal",
              "min-fraction-digits": 6
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      ($setup.locationData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createVNode(_component_GoogleMapsSmall, { location: $setup.locationData }, null, 8, ["location"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_Button, {
          label: $setup.t('content.globalSaveButton'),
          class: "minWidth",
          onClick: $setup.onResearchOrganizationCreateClick
        }, null, 8, ["label", "onClick"])
      ])
    ])
  ]))
}